import { IUpdateEntregaPesquisaSatisfacaoUseCase } from "../../../presentation/useCases/update/update_entrega_pesquisa_satisfacao_use_case";
import { ItemPesquisaEntregaObra } from "../../models/item_pesquisa_entrega_obra";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateEntregaPesquisaSatisfacaoUseCase
 */

export class UpdateEntregaPesquisaSatisfacaoUseCase implements IUpdateEntregaPesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idEntregaPesquisa: number,
    status: number,
    idEntregaObraCliente?: number,
    data?: Date,
    observacao?: string,
    itens?: ItemPesquisaEntregaObra[],
  ): Promise<void> {
    await this.repository.updateEntregaPesquisaSatisfacao(
      idEntregaPesquisa,
      status,
      idEntregaObraCliente,
      data,
      observacao,
      itens,
    );
  }
}
